var map = {
	"./banana.png": "624d",
	"./bench.png": "aee8",
	"./boiler.png": "25e7",
	"./catwalk.png": "2bd0",
	"./dragon.png": "1a30",
	"./forklift.png": "d0f0",
	"./graveyard.png": "231c",
	"./ivy.png": "a6fe",
	"./kitchen.png": "8c79",
	"./library.png": "86b8",
	"./nbk.png": "304b",
	"./palace.png": "184d",
	"./pit.png": "eccf",
	"./plate.png": "1d76",
	"./secret.png": "4dff",
	"./suicide.png": "60bc",
	"./tetris.png": "8851",
	"./ticket.png": "d545"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "329e";